






import { Vue, Component, Prop, PropSync } from 'vue-property-decorator';
import { pattern } from '@/const/regex';

const REGEX = new RegExp(pattern['extra-management-cd'], 'g');

@Component
export default class AdditionalManageCode extends Vue {
  @Prop({ required: true }) private error: any;
  @Prop({ required: true }) private immutableFields: string[];
  @PropSync('extraManagementCd') private extraManagementCdSync!: string;

  private handleExtraManagementCd({ target }: { target: HTMLInputElement }) {
    const value = target.value.replace(REGEX, '');
    const input = this.$refs.extraManagementCd as HTMLInputElement;
    this.extraManagementCdSync = value;
    input.value = value;
  }
}
